var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoParlament(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178.462,
    height: 49.252,
    viewBox: "0 0 178.462 49.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-216.754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.754,0H395.216V49.252H216.754Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.116,
    height: 27.429,
    transform: "translate(265.524 21.629)",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.061,24.609l.391,1.218,1.277-.007-1.037.747.4,1.215-1.032-.757-1.029.757.4-1.215-1.038-.747,1.277.007Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.061,42.907l.391,1.214,1.277-.006-1.037.749.4,1.215-1.032-.755-1.029.755.4-1.215-1.038-.749,1.277.006Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,25.827l.39,1.215,1.276,0-1.033.744.4,1.213-1.032-.755L280.482,29l.4-1.213-1.033-.744,1.277,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.162,29.186l.388,1.215,1.278-.009-1.038.749.4,1.213-1.026-.756-1.03.756.4-1.213-1.041-.749,1.28.009Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.926,33.75l.386,1.213,1.28-.006-1.037.748.4,1.211-1.025-.755-1.03.755.4-1.211-1.039-.748,1.277.006Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.147,38.312l.391,1.221,1.273-.011-1.035.748.4,1.213-1.031-.758-1.031.758.4-1.213-1.038-.745,1.276.008Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,41.668l.39,1.217,1.276-.006-1.033.745.4,1.214-1.032-.754-1.028.754.4-1.214-1.033-.745,1.277.006Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.618,25.827l-.39,1.215-1.28,0,1.039.744-.4,1.213,1.031-.755,1.029.755-.4-1.213,1.035-.744-1.273,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.969,29.186l-.39,1.215-1.279-.009,1.037.749-.4,1.213,1.032-.756,1.031.756-.4-1.213,1.035-.749-1.276.009Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,33.75l-.391,1.213-1.279-.006,1.038.748-.4,1.211,1.032-.755,1.03.755-.4-1.211,1.033-.748-1.276.006Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.977,38.312l-.385,1.221-1.279-.011,1.039.748-.4,1.213,1.027-.758,1.035.758-.4-1.213,1.037-.745-1.279.008Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.618,41.668l-.39,1.217-1.28-.006,1.039.745-.4,1.214,1.031-.754,1.029.754-.4-1.214,1.035-.745-1.273.006Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.084,16.155V13.887a20.947,20.947,0,0,0-6.134-2.567v1.6a15.827,15.827,0,0,1,6.134,3.238Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.755,19.541h1.954a6.325,6.325,0,0,0-2.6-4.891v2.727A3.731,3.731,0,0,1,273.755,19.541Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.617,13.78v2.462a7.6,7.6,0,0,1,2.038,3.311h2.068a10.026,10.026,0,0,0-4.107-5.773Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.358,15.13V12.911a30.946,30.946,0,0,0-9.4-3.691v1.591a26.993,26.993,0,0,1,9.4,4.319Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.674,13.783V11.588a41.989,41.989,0,0,0-12.5-4.61V8.566a38.469,38.469,0,0,1,12.5,5.217Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.146,12.523l-.006,2.36a13.069,13.069,0,0,1,3.794,4.67h2.2c-.751-2.487-3.561-5.5-5.984-7.03Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.605,12.417v-2.2a52.959,52.959,0,0,0-16.066-5.754V6.051c5.855,1.175,12.829,4.068,16.066,6.366Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.647,19.552h2.3c-1.655-3.96-5.8-7.135-7.732-8.344v2.33a18.3,18.3,0,0,1,5.431,6.014Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.442,11.03V8.756a62.185,62.185,0,0,0-19.354-7.063V3.345C281.7,4.719,290.13,8,294.442,11.03Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.112,19.552h2.516a27.8,27.8,0,0,0-9.429-9.7v2.383A24.3,24.3,0,0,1,303.112,19.552Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3,12.472v-1.5a34.348,34.348,0,0,0-7.99-.469v1.175A31.061,31.061,0,0,1,264.3,12.472Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.552,11.785V10.663a17.8,17.8,0,0,0-8.748,3.113v.965C248.184,12.821,251.481,12.026,254.552,11.785Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.834,15.749V14.657c-3.864,4.341.97,7.956,1.485,8.316V21.489C243.617,19.446,243.934,16.957,244.834,15.749Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.781,22.408V24a27.548,27.548,0,0,0,9.02,3.043l-.027-2.157a22.684,22.684,0,0,1-8.993-2.477Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.055,24.953l-.011,2.244c2.2.183,4.27.238,5.4.237V24.909a49.072,49.072,0,0,1-5.39.044Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.312,10.425V8.895a47.607,47.607,0,0,0-11.051-.666v1.19a46.02,46.02,0,0,1,11.051,1.006Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.385,31.37v-2.4c-4.022-.356-10.2-1.76-14.045-4.578v1.6C245.551,29.166,252.21,30.927,255.385,31.37Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.883,24.788V23.2c-3.407-3.24-2.742-6.536-.542-8.659V13.55c-4.229,3.84-2.679,8.487.542,11.238Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.8,29.1v2.488a46.582,46.582,0,0,0,6.648.455V29.293c-2.24.012-5.654-.1-6.648-.2Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.48,12.615v.935c3.664-2.726,9.159-3.825,13.021-4.034V8.373c-4.783.312-10.278,2.145-13.021,4.242Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.519,26.243v1.719c5.256,4.74,13.9,7.321,19.128,8.223V33.506C248.834,32.966,240.135,31.1,234.519,26.243Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.529,8.172V6.662a58.741,58.741,0,0,0-14.763-.79v1.2A60.1,60.1,0,0,1,268.529,8.172Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.193,33.68v2.772a62.61,62.61,0,0,0,8.252.759V34.122c-1.245.044-6.7-.269-8.252-.442Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,7.18V6.017c-4.086.352-11.393,1.807-16.24,5.088v.941C240.48,8.834,247.782,7.409,252,7.18Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.433,13v-.958c-2.217,1.672-7.655,7.311-1.361,14.448V24.763c-1.4-1.564-4.776-6.63,1.361-11.759Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.892,5.7V4.146a73.951,73.951,0,0,0-18.432-.887v1.2A75.439,75.439,0,0,1,270.892,5.7Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.479,38.429V41.36a68.9,68.9,0,0,0,9.966,1.08V39.113a80.848,80.848,0,0,1-9.966-.684Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.785,41.083V38.246c-8.626-1.22-18.13-4.362-24.02-10.137v1.83c6.978,6.951,18.552,10.154,24.02,11.143Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,9.444v.923c5.767-3.67,13.667-5.248,19.7-5.783V3.417c-5.8.5-14.3,2.479-19.7,6.028Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.309,28.167V26.28c-2.258-3.078-4.473-9.15,3.329-14.964v-.949c-8.762,6.265-6.578,13.933-3.329,17.8Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.259,29.35V31.4c6.619,8.585,20.286,13.64,28.785,15.43V43.691c-8.929-1.512-22.495-5.887-28.785-14.341Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.422,2.99V1.381A85.654,85.654,0,0,0,250.754.341V1.578A87.282,87.282,0,0,1,273.422,2.99Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.995,1.728V.519c-7.558.771-16.941,3.385-22.425,6.968v.958C233.459,4.221,242.6,2.333,248.995,1.728Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.889,43.989V47.2a84.86,84.86,0,0,0,12.556,1.574V45.094a112.356,112.356,0,0,1-12.556-1.1Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.092,9.419V8.445c-2.218,1.43-12.721,9.316-6.269,20.7V26.846c-4.036-8.388,2.116-14.476,6.269-17.427Z",
    fill: "#878d91"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.915,
    height: 27.513,
    transform: "translate(319.307 21.603)",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.077,30.666H333.9v2.91h2.474V34.84h-3.929V25.677h3.767V26.94H333.9v2.516h2.175v1.209Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.273,32.909c0,.721.028,1.374.057,1.932h-1.265l-.082-.694h-.027a1.8,1.8,0,0,1-1.482.8c-1.211,0-1.7-.909-1.7-2.637V28.218h1.454v3.916c0,.952.164,1.6.761,1.6a.8.8,0,0,0,.748-.652,1.73,1.73,0,0,0,.081-.57v-4.3h1.454v4.69Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.159,30.081c0-.611-.028-1.305-.056-1.863h1.265l.081.993h.041a1.569,1.569,0,0,1,1.346-1.1,1.863,1.863,0,0,1,.313.027v1.442a2.122,2.122,0,0,0-.313-.014,1.314,1.314,0,0,0-1.17,1.142,3.766,3.766,0,0,0-.053.625V34.84h-1.454V30.081Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.562,34.949c-1.4,0-2.365-1.169-2.365-3.4,0-2.406,1.183-3.44,2.42-3.44,1.386,0,2.338,1.21,2.338,3.4,0,2.68-1.387,3.441-2.379,3.441Zm.055-1.115c.721,0,.883-1.305.883-2.312,0-.963-.163-2.3-.91-2.3-.789,0-.939,1.335-.939,2.3,0,1.117.191,2.312.953,2.312Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.561,30.3c0-.9-.027-1.524-.055-2.081h1.264l.082.8h.027a1.5,1.5,0,0,1,1.387-.911c1.319,0,2,1.414,2,3.4,0,2.422-1.031,3.441-2.106,3.441a1.263,1.263,0,0,1-1.128-.693H356v3.195h-1.441V30.3ZM356,32.42a2.29,2.29,0,0,0,.067.556c.177.639.517.776.763.776.734,0,.978-1.048.978-2.216,0-1.318-.311-2.2-.978-2.2-.368,0-.693.41-.775.858a1.844,1.844,0,0,0-.054.489Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.937,33.331a10.6,10.6,0,0,0,.082,1.509h-1.306l-.081-.668h-.027a1.649,1.649,0,0,1-1.4.776,1.762,1.762,0,0,1-1.673-1.959c0-1.7,1.44-2.419,2.937-2.431v-.177c0-.694-.272-1.17-.992-1.17a2.248,2.248,0,0,0-1.238.368l-.273-.994a3.709,3.709,0,0,1,1.822-.474c1.715,0,2.149,1.17,2.149,2.582v2.639Zm-3.168-6.157a.749.749,0,0,1,.013-1.5.75.75,0,0,1,0,1.5Zm1.74,4.348c-.57.014-1.59.165-1.59,1.319,0,.749.393,1.021.719,1.021a.871.871,0,0,0,.83-.762,1.368,1.368,0,0,0,.04-.339V31.522Zm.544-4.348a.749.749,0,0,1,.014-1.5.75.75,0,0,1,0,1.5Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.477,27.336a.847.847,0,0,1,.014-1.687.845.845,0,0,1,0,1.687h-.014Zm-.693,7.5V28.218h1.454V34.84Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,33.468a2.233,2.233,0,0,0,1.14.352.727.727,0,0,0,.829-.76c0-.408-.19-.68-.8-1.076a2.206,2.206,0,0,1-1.346-1.888,1.932,1.932,0,0,1,2.025-1.985,2.555,2.555,0,0,1,1.265.327l-.286,1.073a1.694,1.694,0,0,0-.91-.286.68.68,0,0,0-.748.7c0,.352.163.558.787.964a2.339,2.339,0,0,1,1.361,2.011,1.958,1.958,0,0,1-2.19,2.026,2.546,2.546,0,0,1-1.412-.38L370,33.468Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.329,34.7a2.623,2.623,0,0,1-1.114.217c-1.578,0-2.623-1.169-2.623-3.342,0-1.987,1.1-3.455,2.854-3.455a2.269,2.269,0,0,1,.951.192l-.217,1.156a1.854,1.854,0,0,0-.708-.151c-.938,0-1.427,1.005-1.427,2.23,0,1.359.544,2.174,1.427,2.174a1.656,1.656,0,0,0,.708-.148l.149,1.128Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.7,25.434h1.454v3.481h.027a1.816,1.816,0,0,1,.57-.559,1.69,1.69,0,0,1,.884-.245c1.047,0,1.631.87,1.631,2.543V34.84H382.81V30.706c0-.719-.15-1.373-.762-1.373-.38,0-.693.258-.843.815a2.769,2.769,0,0,0-.054.5V34.84H379.7V25.433Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.266,31.917c.013,1.483.693,1.888,1.469,1.888a3.042,3.042,0,0,0,1.183-.229l.217,1.034a4.353,4.353,0,0,1-1.659.311c-1.714,0-2.625-1.236-2.625-3.289,0-2.19,1.048-3.522,2.461-3.522,1.387,0,2.095,1.266,2.095,3.032a5.182,5.182,0,0,1-.041.776h-3.1Zm1.794-1.033c.014-1.06-.339-1.687-.856-1.687-.627,0-.911.913-.938,1.687Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.9,33.468a2.227,2.227,0,0,0,1.143.352.728.728,0,0,0,.829-.76c0-.408-.19-.68-.8-1.076a2.2,2.2,0,0,1-1.345-1.888,1.932,1.932,0,0,1,2.025-1.985,2.553,2.553,0,0,1,1.264.327l-.286,1.073a1.7,1.7,0,0,0-.911-.286.681.681,0,0,0-.748.7c0,.352.163.558.79.964a2.343,2.343,0,0,1,1.359,2.011,1.958,1.958,0,0,1-2.189,2.026,2.545,2.545,0,0,1-1.414-.38l.286-1.073Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.484,40.083a7.823,7.823,0,0,1,1.7-.176,3.2,3.2,0,0,1,2.3.694,2.638,2.638,0,0,1,.734,1.957,2.785,2.785,0,0,1-2.881,2.991,3.841,3.841,0,0,1-.409-.014v3.577h-1.44V40.083Zm1.44,4.255a1.341,1.341,0,0,0,.356.028c.949,0,1.48-.653,1.48-1.7,0-.854-.352-1.575-1.331-1.575a1.627,1.627,0,0,0-.5.068v3.181Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.659,47.6a10.722,10.722,0,0,0,.081,1.509h-1.305l-.081-.668h-.026a1.65,1.65,0,0,1-1.4.776,1.763,1.763,0,0,1-1.674-1.959c0-1.7,1.441-2.419,2.938-2.431v-.177c0-.694-.272-1.17-.993-1.17a2.248,2.248,0,0,0-1.238.368l-.273-.994a3.715,3.715,0,0,1,1.822-.474c1.715,0,2.15,1.17,2.15,2.582V47.6Zm-1.427-1.809c-.571.014-1.591.165-1.591,1.319,0,.749.4,1.021.721,1.021a.872.872,0,0,0,.829-.762,1.3,1.3,0,0,0,.041-.339Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.512,44.352c0-.611-.025-1.305-.053-1.863h1.264l.082.993h.042a1.568,1.568,0,0,1,1.345-1.1,1.883,1.883,0,0,1,.314.027V43.85a2.144,2.144,0,0,0-.314-.014,1.313,1.313,0,0,0-1.169,1.142,3.649,3.649,0,0,0-.056.625v3.509h-1.454V44.352Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,39.7h1.454v9.407H348.8Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.185,47.6a10.157,10.157,0,0,0,.082,1.509h-1.306l-.082-.668h-.027a1.651,1.651,0,0,1-1.4.776,1.761,1.761,0,0,1-1.67-1.959c0-1.7,1.44-2.419,2.936-2.431v-.177c0-.694-.272-1.17-1-1.17a2.251,2.251,0,0,0-1.236.368l-.271-.994a3.692,3.692,0,0,1,1.82-.474c1.712,0,2.149,1.17,2.149,2.582V47.6Zm-1.428-1.809c-.572.014-1.591.165-1.591,1.319,0,.749.4,1.021.723,1.021a.871.871,0,0,0,.829-.762,1.4,1.4,0,0,0,.039-.339V45.793Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.038,44.352c0-.748-.028-1.277-.053-1.863h1.264l.068.79h.028a1.821,1.821,0,0,1,1.549-.9,1.41,1.41,0,0,1,1.412.952h.028a2.191,2.191,0,0,1,.653-.707,1.777,1.777,0,0,1,.925-.245c1.059,0,1.659.815,1.659,2.449v4.282h-1.44V45.1c0-.8-.109-1.511-.748-1.511-.381,0-.681.286-.8.776a1.905,1.905,0,0,0-.057.531v4.214h-1.44V44.869c0-.583-.082-1.279-.734-1.279-.353,0-.695.272-.815.8a2.922,2.922,0,0,0-.057.531v4.187h-1.44V44.352Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.594,46.188c.014,1.483.7,1.888,1.469,1.888a3.018,3.018,0,0,0,1.183-.229l.218,1.034a4.341,4.341,0,0,1-1.659.311c-1.712,0-2.622-1.236-2.622-3.289,0-2.19,1.045-3.522,2.46-3.522,1.386,0,2.093,1.266,2.093,3.032a5.048,5.048,0,0,1-.042.776h-3.1Zm1.8-1.033c.014-1.06-.342-1.687-.857-1.687-.626,0-.911.913-.939,1.687h1.8Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.307,44.352c0-.748-.028-1.277-.057-1.863h1.264l.071.776h.025a1.779,1.779,0,0,1,1.564-.884c1.115,0,1.7.856,1.7,2.392v4.338H376.42v-4.2c0-.667-.137-1.307-.776-1.307-.354,0-.682.272-.815.815a2.206,2.206,0,0,0-.068.6v4.092h-1.454V44.352Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.422,40.845v1.645H382.7v1.048h-1.278v3.438c0,.817.311,1.019.678,1.019a2.461,2.461,0,0,0,.452-.039l.025,1.128a3.318,3.318,0,0,1-.949.108,1.624,1.624,0,0,1-1.172-.407,2.344,2.344,0,0,1-.488-1.8V43.537h-.79V42.489h.79v-1.14l1.454-.5Z",
    fill: "#646464"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoParlament);
export default __webpack_public_path__ + "static/media/logo-parlament.995d2e1e797797c497dd2871d4d32bd7.svg";
export { ForwardRef as ReactComponent };